import { TableCell } from '@material-ui/core'
import classNames from 'classnames'
import React from 'react'
import { useSummaryRowStyles } from './styles'

export function SummaryCell ({ topContent, bottomContent, className }) {
  const classes = useSummaryRowStyles()

  return <TableCell className={classNames(classes.tableCell, className)}>
    <div>{topContent}</div>
    <div>{bottomContent}</div>
  </TableCell>
}
